interface Props {
    className?: string
    FillColor?: string
}

export default function DeepDive({className, FillColor}:Props) {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" className={className}>
            <path
                d="M4.64242 3.46144C4.83774 3.17287 5.1635 3 5.51196 3H18.489C18.8375 3 19.1632 3.17287 19.3585 3.46144L22.2463 7.72782C22.5065 8.11227 22.4834 8.62197 22.1894 8.98127L12.8131 20.4411C12.393 20.9546 11.6079 20.9546 11.1878 20.4411L1.81157 8.98127C1.51759 8.62197 1.49446 8.11226 1.75468 7.72782L4.64242 3.46144ZM3.72018 7.5H7.62687L8.11778 4.5H5.75076L3.72018 7.5ZM9.14682 7.5H14.8541L14.3632 4.5H9.63773L9.14682 7.5ZM14.6863 9H9.31478L12.0005 16.5201L14.6863 9ZM7.72198 9H3.76498L10.7873 17.5828L7.72198 9ZM16.2791 9L13.2138 17.5826L20.236 9H16.2791ZM20.2808 7.5L18.2502 4.5H15.8832L16.3741 7.5H20.2808Z"
                fill={FillColor}/>
        </svg>
    )
}
